import React from 'react';
import Loader from '../Loader';
import { IPetsyPriceProps } from './PetsyPrice.types';
import './PetsyPrice.scss';
import { formatString, StringFormats } from '@adaptis/flow-components';

export default function PetsyPrice(props: IPetsyPriceProps) {
  let wasPrice = props.wasPrice
    ? formatString(props.wasPrice, StringFormats.Currency)
    : '';
  let price = formatString(props.price, StringFormats.Currency);

  return (
    <div
      data-testid='PetsyPrice'
      className={
        'flc_petsy-price' + (props.className ? ' ' + props.className : '')
      }>
      {props.isLoading && <Loader className='loader' />}
      <div>
        {wasPrice && !props.isLoading && (
          <div className='was'>
            <svg>
              <line strokeWidth='0.1em' x1='0' y1='50%' x2='100%' y2='50%' />
            </svg>
            {wasPrice}
          </div>
        )}
        <div className={'now ' + (props.isLoading ? 'fade' : '')}>{price}</div>
      </div>
    </div>
  );
}
